import { Platform, StyleProp } from 'react-native';

import {
    ImageStyle,
    Priority,
    ResizeMode,
    Source,
} from 'react-native-fast-image';

import {
    getScreenSize,
    isPhone,
    isTablet,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const ImageSize = {
    BACKGROUND: {
        width: getScreenSize('width'),
        height: getScreenSize('height'),
    },
    LANDSCAPE: { width: 320, height: 180 },
    PORTRAIT: { width: 288, height: 432 },
    GALLERY: { width: 1920, height: 810 },
    TEASER: { width: 1920, height: 810 },
    PERSON: { width: 256, height: 256 },
    SUBSCRIPTIONS: {
        width: 1280,
        height: Platform.select({
            web: 504,
            default: isTablet ? 424 : 300,
        }),
    },
    CHANNEL_LOGO: { width: 38, height: 16 },
    BIG_CHANNEL_LOGO: { width: 40, height: 27 },
    EXTRA_LARGE_CHANNEL_LOGO: { width: 104, height: 52 },
    SETTINGS_LIST_CHANNEL_LOGO: { width: 64, height: 26 },
    ZAPPING_OVERLAY_CHANNEL_LOGO: { width: 156 },
    GALLERY_CHANNEL_LOGO: { height: 32 },
    PLAYER_CHANNEL_LOGO: { height: 20 },
    PROFILE_IMAGE: { width: isPhone ? widthPercentageToDP(104) : 132 },
};

export enum ImageContentType {
    MOVIE = 'movie',
    EPISODE = 'episode',
    TVSHOW = 'tvshow',
    NEWS = 'news',
    CHANNEL = 'channel',
    VOD_DEEPLINK = 'vod-deeplink',
    PERSON = 'person',
    PROMO = 'promo',
    PROFILE = 'profile',
    ANY = 'any',
}

export enum ImageType {
    BANNER = 'banner',
    CHARACTER = 'character',
    CONTENT_IMAGE = 'contentimage',
    LOGO = 'logo',
    POSTER = 'poster',
    GALLERY = 'gallery',
    EPISODE = 'episode',
    AVATAR = 'avatar',
    BACKGROUND = 'background',
    PROMO = 'promo',
    ANY = 'any',
}

export enum AspectRatio {
    PORTRAIT = '2x3',
    LANDSCAPE = '16x9',
    TEASER = '16x9',
    PERSON = '1x1',
}

export type NagraImageUrlParams = {
    contentId: string;
    contentType?: ImageContentType | string | null;
    imageType?: ImageType;
    width?: number;
    height?: number;
    aspect?: AspectRatio;
};

export type Props = NagraImageUrlParams & {
    source?: string | number;
    style?: StyleProp<ImageStyle>;
    resizeMode?: ResizeMode;
    cache?: Source['cache'];
    priority?: Priority;
    onLoad?(): void;
    onError?(): void;
    testID?: string;
    withBase64?: boolean;
};
